import React, { Component, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Empty } from '@/views/account/assets/icons/empty.svg';
import { GAPersonalSettingPageDisplay } from '../../../../ga/personalCenter';
import { Table, message } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import sentGAEvent from '../../../../ga/index';
const SubscriptionHistory = () => {
  const { t } = useTranslation(['personalCenterHistory', 'common']);
  const subscriptionData =
    useSelector((state) => state.account.subscription) || [];
  const dataSource = subscriptionData.sort((a, b) => {
    if (a.status === 'Expired' && b.status !== 'Expired') {
      return 1;
    } else if (a.status !== 'Expired' && b.status === 'Expired') {
      return -1;
    } else {
      return 0;
    }
  });

  const navigate = useNavigate();
  const tableSource = dataSource || [];

  useEffect(() => {
    if (tableSource.length === 0) {
      message.info(t('upgradePersonal:NoValidSubscription'), 1);
    }
  }, []);
  useEffect(() => {
    sentGAEvent({
      category: 'EnterPage',
      action: 'V2_EnterPage',
      label: 'V2SubPage',
    });
    GAPersonalSettingPageDisplay();
  }, []);

  const tableColumns = [
    {
      title: t('personalCenterProfile:tableProduct'),
      dataIndex: 'product_name',
      key: 'product',
      render: (text, record) => (
        <span style={{ color: record.status === 'Active' ? '' : '#9F9FA1' }}>
          {text}
        </span>
      ),
      width: 375,
    },
    {
      title: t('personalCenterProfile:tableStatus'),
      dataIndex: 'status',
      key: 'status',
      render: (text) =>
        text === 'Active' ? (
          <span style={{ color: '#6B57FF' }}>
            {t('personalCenterProfile:validStauts')}
          </span>
        ) : (
          <span style={{ color: '#9F9FA1' }}>
            {t('personalCenterProfile:expiredStauts')}
          </span>
        ),
      width: 155,
    },
    {
      title: t('personalCenterProfile:tablePermissionDate'),
      dataIndex: 'create_time',
      key: 'orderDate',
      render: (text, record) => (
        <span style={{ color: record.status === 'Active' ? '' : '#9F9FA1' }}>
          {text}
        </span>
      ),
      width: 260,
    },
    {
      title: t('personalCenterProfile:tableValidPeriod'),
      dataIndex: 'active_Time',
      key: 'validPeriod',
      render: (text, record) => (
        <span style={{ color: record.status === 'Active' ? '' : '#9F9FA1' }}>
          {text}
        </span>
      ),
    },
  ];

  return (
    <>
      <div className='userSubscription'>
        <div className='subscriptionHistory'>
          {t('upgradePersonal:SubscriptionHistory')}
        </div>
        <Table
          scroll={{ y: 600 }}
          className='subscriptionTable'
          dataSource={tableSource}
          columns={tableColumns.map((item) => {
            // 通过配置 给每个单元格添加不换行属性
            const fun = () => ({ style: { whiteSpace: 'nowrap' } });
            item.onHeaderCell = fun;
            item.onCell = fun;
            return item;
          })}
          bordered
          pagination={false}
          locale={{ emptyText: <span> {t('noData')}</span> }}
        ></Table>
      </div>
    </>
  );
};

export default SubscriptionHistory;
